import React, {Component} from 'react'
import EmptyFavoritesImg from "../../assets/images/empty_favorites.png";
import "./EmptyFavorites.css";

export class EmptyFavorites extends Component {
    render(){
        return (
            <div
                className='empty-favorites-wrapper'
            >
                <img 
                    className='empty-favorites-img'
                    src={EmptyFavoritesImg} 
                    alt="empty" 
                />
                <p
                    className='empty-favorites-p'
                >
                    ¿Quieres hacer una colección?<br />Marca tus assets como favoritos
                </p>
            </div>
        )
    }
}

export default EmptyFavorites;
